
export const COUPLE_AMOUNT = -5;
export const FAMILY_SB_AMOUNT = -10;
export const MULTIPLE_COURSES_AMOUNT = -5;
export const ANNUAL_FEES_AMOUNT = 18;
